/**
 * This validator checks that the two input parameters are same or not
 */
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ConfirmMatchValidator {
  static match(confirm: string, actual: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const confirmController = formGroup.get(confirm);
      const actualController = formGroup.get(actual);

      if (!confirmController) {
        throw new Error('Form Controller named' + confirm + 'not found');
      }
      if (!actualController) {
        throw new Error('Form Controller named' + actual + 'not found');
      }
      if (confirmController.value && confirmController.value !== actualController.value) {

        return { match: true };
      }
      return null;
    };
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/update-profile/validators/confirm-match-validator.ts